import axiosInstance from '../../api/axios';

const baseUrl = '/notifications';

const NotificationService = {
  getNotifications: async () => {
    try {
      const response = await axiosInstance.get(baseUrl);
      if (response.data) {
        return response.data;
      } else {
        throw new Error('Failed to fetch notifications');
      }
    } catch (error) {
      throw error;
    }
  },

  markAsRead: async (id) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/${id}/read`);
      if (response.data.message === 'Notification marked as read') {
        return response.data.message;
      } else {
        throw new Error('Failed to mark notification as read');
      }
    } catch (error) {
      throw error;
    }
  },

  markAllAsRead: async () => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/read-all`);
      if (response.data.message === 'All notifications marked as read') {
        return response.data.message;
      } else {
        throw new Error('Failed to mark all notifications as read');
      }
    } catch (error) {
      throw error;
    }
  },
};

export default NotificationService;